import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Components/baseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Menu from "../Components/Menu";
import Map, { Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
const Profile = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | پروفایل";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [profileDet, setProfileDet] = useState([]);
    useEffect(() => {
        let config = {
            url: `${baseUrl}/profile`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setProfileDet(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);

    // const startVisitHandler = (i) => {
    //     let currentDate = new Date();
    //     const formattedDate = `${currentDate.getFullYear()}-${(
    //         currentDate.getMonth() + 1
    //     )
    //         .toString()
    //         .padStart(2, "0")}-${currentDate
    //         .getDate()
    //         .toString()
    //         .padStart(2, "0")}`;

    //     // تبدیل زمان به رشته با فرمت 18:17
    //     const formattedTime = `${currentDate
    //         .getHours()
    //         .toString()
    //         .padStart(2, "0")}:${currentDate
    //         .getMinutes()
    //         .toString()
    //         .padStart(2, "0")}`;
    //     let data = new FormData();
    //     data.append("date", formattedDate);
    //     data.append("time", formattedTime);
    //     let config = {
    //         method: "POST",
    //         url: `${baseUrl}/worktime`,
    //         data: data,
    //     };
    //     axios(config)
    //         .then((response) => {
    //             toast.success(response.data.message, {
    //                 position: "top-center",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //         })
    //         .catch(function (err) {
    //             toast.error(err.response.data.message, {
    //                 position: "top-center",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //         });
    // };
    return (
        <div className="container">
            {profileDet && profileDet?.length !== 0 && (
                <div className="profile-main">
                    <div className="profile-img-div">
                        <img src={profileDet?.avatar} alt="profile" />
                        <a href="/panel/setting">
                            <svg
                                width="15"
                                height="26"
                                viewBox="0 0 15 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13.5 1L2.20711 12.2929C1.81658 12.6834 1.81658 13.3166 2.20711 13.7071L13.5 25"
                                    stroke="black"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </a>
                    </div>
                    <h2 className="name">
                        {profileDet?.name} {profileDet?.family}
                    </h2>
                    <span className="d-flex align-items-center fw-bold">
                        {profileDet?.rate && (
                            <div className="pb-1">
                                <svg
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.4"
                                        d="M5.74132 16.5C5.85132 16.01 5.65132 15.31 5.30132 14.96L2.87132 12.53C2.11132 11.77 1.81132 10.96 2.03132 10.26C2.26132 9.56 2.97132 9.08 4.03132 8.9L7.15132 8.38C7.60132 8.3 8.15132 7.9 8.36132 7.49L10.0813 4.04C10.5813 3.05 11.2613 2.5 12.0013 2.5C12.7413 2.5 13.4213 3.05 13.9213 4.04L15.6413 7.49C15.7713 7.75 16.0413 8 16.3313 8.17L5.56132 18.94C5.42132 19.08 5.18132 18.95 5.22132 18.75L5.74132 16.5Z"
                                        fill="url(#paint0_linear_4355_5968)"
                                    />
                                    <path
                                        d="M18.7008 14.9599C18.3408 15.3199 18.1408 16.0099 18.2608 16.4999L18.9508 19.5099C19.2408 20.7599 19.0608 21.6999 18.4408 22.1499C18.1908 22.3299 17.8908 22.4199 17.5408 22.4199C17.0308 22.4199 16.4308 22.2299 15.7708 21.8399L12.8408 20.0999C12.3808 19.8299 11.6208 19.8299 11.1608 20.0999L8.23078 21.8399C7.12078 22.4899 6.17078 22.5999 5.56078 22.1499C5.33078 21.9799 5.16078 21.7499 5.05078 21.4499L17.2108 9.2899C17.6708 8.8299 18.3208 8.6199 18.9508 8.7299L19.9608 8.8999C21.0208 9.0799 21.7308 9.5599 21.9608 10.2599C22.1808 10.9599 21.8808 11.7699 21.1208 12.5299L18.7008 14.9599Z"
                                        fill="url(#paint1_linear_4355_5968)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_4355_5968"
                                            x1="3.93373"
                                            y1="3.23993"
                                            x2="16.5589"
                                            y2="17.2665"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#FFDA1C" />
                                            <stop
                                                offset="1"
                                                stop-color="#FEB705"
                                            />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_4355_5968"
                                            x1="7.38188"
                                            y1="9.31655"
                                            x2="16.928"
                                            y2="24.3852"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#FFDA1C" />
                                            <stop
                                                offset="1"
                                                stop-color="#FEB705"
                                            />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        )}
                        {profileDet?.rate && profileDet?.rate}
                    </span>
                    <div className="number">
                        <span>موبایل</span>
                        <span className="num">
                            {profileDet?.mobile && profileDet?.mobile}{" "}
                        </span>
                    </div>
                    <div className="px-20">
                        <div className="profile-data">
                            <div>
                                <span className="span-1">استان </span>
                                <span className="span-2">
                                    {profileDet?.location?.state?.name}
                                </span>
                            </div>
                            <svg
                                width="4"
                                height="60"
                                viewBox="0 0 4 60"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 2L2 58"
                                    stroke="#DCDCDC"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <div>
                                <span className="span-1">شهر </span>
                                <span className="span-2">
                                    {profileDet?.location?.city?.name}
                                </span>
                            </div>
                            <svg
                                width="4"
                                height="60"
                                viewBox="0 0 4 60"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 2L2 58"
                                    stroke="#DCDCDC"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <div>
                                <span className="span-1">منطقه تحت پوشش </span>
                                <span className="span-2">
                                    {profileDet?.location?.region?.name}
                                </span>
                            </div>
                        </div>
                        <div className="profile-data">
                            <div>
                                <span className="span-1">صنف </span>
                                <span className="span-2">
                                    {profileDet?.guild?.name}{" "}
                                </span>
                            </div>
                            <svg
                                width="4"
                                height="60"
                                viewBox="0 0 4 60"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 2L2 58"
                                    stroke="#DCDCDC"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <div>
                                <span className="span-1">تلفن ثابت </span>
                                <span className="span-2">
                                    {profileDet?.phone}{" "}
                                </span>
                            </div>
                            <svg
                                width="4"
                                height="60"
                                viewBox="0 0 4 60"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 2L2 58"
                                    stroke="#DCDCDC"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <div>
                                <span className="span-1">وضعیت </span>
                                <span className="span-2">
                                    {/* {profileDet?.visit_type == "faceToFace"
                                        ? "حضوری"
                                        : profileDet?.visit_type == "warm"
                                        ? "گرم"
                                        : "تلفنی"}{" "} */}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="number mb-4">
                        <span>آدرس فروشگاه</span>
                        <span className="num text-center">
                            {profileDet?.address}
                        </span>
                    </div>

                    <Map
                        style={{ height: "160px" }}
                        initialViewState={{
                            longitude: 51.375433528216654,
                            latitude: 35.73356434056531,
                            zoom: 11,
                        }}
                        mapboxAccessToken="pk.eyJ1IjoiYWxkZjkyIiwiYSI6ImNscHh5ZG56dTByMXAycnJ2cDNmdDQ5M3YifQ.a_sUt1rLFMfA0jHrETcM7A"
                        mapStyle="mapbox://styles/mapbox/streets-v11"
                        transformRequest={(url) => {
                            return {
                                url,
                            };
                        }}
                        // onClick={handleMapClick}
                    >
                        {/* {selectedLocation && (
                    <Marker
                        latitude={selectedLocation.lat}
                        longitude={selectedLocation.lng}
                        offsetLeft={-20}
                        offsetTop={-10}
                    >
                        <svg
                            width="24"
                            height="27"
                            viewBox="0 0 57 65"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M55.4409 21.4062C52.1597 6.96875 39.5659 0.46875 28.5034 0.46875C28.5034 0.46875 28.5034 0.46875 28.4722 0.46875C17.4409 0.46875 4.81585 6.9375 1.5346 21.375C-2.12165 37.5 7.75335 51.1562 16.6909 59.75C20.0034 62.9375 24.2534 64.5312 28.5034 64.5312C32.7534 64.5312 37.0034 62.9375 40.2847 59.75C49.2222 51.1562 59.0972 37.5312 55.4409 21.4062ZM28.5034 37.0625C23.0659 37.0625 18.6596 32.6562 18.6596 27.2188C18.6596 21.7813 23.0659 17.375 28.5034 17.375C33.9409 17.375 38.3472 21.7813 38.3472 27.2188C38.3472 32.6562 33.9409 37.0625 28.5034 37.0625Z"
                                fill="#1AA3B9"
                            />
                        </svg>
                    </Marker>
                )} */}
                    </Map>
                    <div className="btns">
                        <button
                            onClick={() => navigate("/panel/edit_profile")}
                            className="start"
                        >
                            ویرایش
                        </button>
                    </div>
                </div>
            )}

            <Menu active="setting" />
        </div>
    );
};

export default Profile;
